import { render, staticRenderFns } from "./DynamicMaterials.vue?vue&type=template&id=63c2ddab&scoped=true"
import script from "./DynamicMaterials.vue?vue&type=script&lang=js"
export * from "./DynamicMaterials.vue?vue&type=script&lang=js"
import style0 from "./DynamicMaterials.vue?vue&type=style&index=0&id=63c2ddab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c2ddab",
  null
  
)

export default component.exports